/**
 * Per-tenant enrollment-number mask configuration (SchoolService, PR #50).
 *
 * The SchoolService serializes PascalCase across the board (the runtime response
 * is `{ "Mask", "IsDefault", "Example" }`), so these DTOs are PascalCase too —
 * 1:1 with the wire format, no mappers.
 */

/** GET/PUT `/EnrollmentNumberSetting` response. */
export interface EnrollmentNumberSetting {
  /** The effective mask — the tenant's own, or the service default. */
  Mask: string;
  /** True while the tenant still uses the service default (no row stored). */
  IsDefault: boolean;
  /** Server-rendered sample of the resulting number (e.g. `2026100001`). */
  Example: string;
}

/** PUT `/EnrollmentNumberSetting` body. */
export interface EnrollmentNumberSettingRequest {
  Mask: string;
}

export interface EnrollmentNumberSettingState {
  /** Effective setting from the last successful load/save (null until loaded). */
  setting: EnrollmentNumberSetting | null;
}

export const initialEnrollmentNumberSettingState: EnrollmentNumberSettingState = {
  setting: null,
};
